import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { downloadChainStoreContractAttachment } from '../../api/chain-store-contract.ts';

import type { DownloadChainStoreContractAttachmentRequest } from '../../api/requests/chain-store-contract-request.ts';

export default function useDownloadChainStoreContractAttachment(): UseMutationResult<
  string,
  Error,
  DownloadChainStoreContractAttachmentRequest
> {
  return useMutation({
    mutationFn: async (
      request: DownloadChainStoreContractAttachmentRequest,
    ) => {
      const response = await downloadChainStoreContractAttachment(request);
      return response.data.downloadUrl;
    },
  });
}
